import React, { useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Post } from '@app/utils/httpProvider';
import { TIMESLOTS_API } from '@app/utils/apiUrl';
import { useMutation } from 'react-query';
import {
    messageError,
    messageToast,
    status200,
} from '../../../utils/define';
import ReactSpinner from '../../../components/reactSpinner/ReactSpinner';

/**
 * @typedef {Object} TimeSlots
 * @property {string} time
 * @property {int} orderNumber
 * @property {boolean} isActive
 */

const schema = yup.object().shape({
    time: yup.string().required(messageError.emptyMessage),
});

const TimeSlotsAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(TIMESLOTS_API.CREATE, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = { ...values };
        try {
            addFunc.mutate(model, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastCreateError);
                    } else {
                        setIsLoading(true);
                        toast.success(messageToast.messageToastCreateSuccess);
                        history.goBack();
                    }
                },
                onError: (res) => {
                    toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
                }
            });
        }
        catch (error) {
            toast.error("Có lỗi xảy ra khi xóa!");
        }

    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới khung giờ</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        time: '',
                        orderNumber: 0,
                        isActive: true
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Khung giờ - hh:mm *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Khung giờ hh:mm"
                                        type="text"
                                        name="time"
                                        value={values.time}
                                        onChange={handleChange}
                                        isInvalid={!!errors.time}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.time}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Trạng thái kích hoạt
                                </Form.Label>
                                <Col sm="10" className="icheck-primary">
                                    <Form.Control
                                        id="checkboxPrimary1"
                                        type="checkbox"
                                        placeholder="Trạng thái"
                                        name="isActive"
                                        checked={values.isActive}
                                        onClick={handleChange}
                                    />
                                    <Form.Label htmlFor="checkboxPrimary1">
                                        {' '}
                                    </Form.Label>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Thứ tự hiển thị
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="number"
                                        name="orderNumber"
                                        placeholder="Thứ tự hiển thị"
                                        value={values.orderNumber}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() =>
                                                history.goBack()
                                            }
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default TimeSlotsAdd;
